import OrderedFoodComponent from "./OrderedFoodComponent";
import ViewOrderLogModal from "../../modals/ViewOrderLogModal";
import { useEffect, useState } from "react";
import moment from "moment";
import useUserStore from "../../../stores/store";
import { useNavigate } from "react-router-dom";
import { Divider, message, Spin } from "antd";
import { getParsedNumber } from "../../../utils/Common";
import ApiService from "../../../utils/ApiService";
import OrderPaymentModal from "../../modals/OrderPaymentModal";
import { getFormatedOrderDataForList, getNetTotalOrderDetails, getSubtotalPriceToDisplay } from "../../../services/order-details-service";
import ConfirmModal from "../../modals/ConfirmModal";
import OrderPaymentRefundModal from "../../modals/OrderPaymentRefundModal";
import { navToPayment, redirectToTargetPage, showTableNumbers } from "../../../services/order-common-service";
import { getQueryParamsOrderForm } from "../../../services/order-add-edit-service";

export default function OrderDetailsComponent({ record }) {
  const { user, tableManagement, setNetworkCall } = useUserStore();
  const navigate = useNavigate();
  const { sourcePage, orderPageNo } = getQueryParamsOrderForm();

  const [isPaymentModalOpen, setIsPaymentModalOpen] = useState(false);
  const [isOrderRefundModalOpen, setIsOrderRefundModalOpen] = useState(false);
  const [orderDetails, setOrderDetails] = useState({});
  const [isViewLogModalOpen, setIsViewLogModalOpen] = useState(false);
  const [editLogs, setEditLogs] = useState([]);
  const [statusLogs, setStatusLogs] = useState([]);
  const [refundInfo, setRefundInfo] = useState(null);
  const [statusChangeParams, setStatusChangeParams] = useState({
    orderId: "",
    selection: 0,
    cookingTime: "",
    payAfterEat: "",
    tableNumber: "",
  });
  const [isOrderDeclineLoading, setIsOrderDeclineLoading] = useState(false);
  const [isOrderDeclineConfirmed, setIsOrderDeclineConfirmed] = useState(false);

  function getLogs(orderObj) {
    if (orderObj.hasOwnProperty("staffOrderEditLogs")) {
      setEditLogs(orderObj.staffOrderEditLogs);
    }
    if (orderObj.hasOwnProperty("statusChangeLogs")) {
      setStatusLogs(orderObj.statusChangeLogs);
    }
  }

  function handleOrderChangeParams(orderObj) {
    setStatusChangeParams((prevParams) => {
      return {
        ...prevParams,
        orderId: orderObj.id,
        payAfterEat: orderObj.payAfterEat,
        tableNumber: orderObj.tableNumber,
      };
    });
  }

  useEffect(() => {
    if (record) {
      getLogs(record.order);
      handleOrderChangeParams(record.order);
    }

    // For refund purpose
    if (record && record.order && record.order.refundInfo) {
      setRefundInfo(record.order.refundInfo);
    }
  }, [record]);

  function onCloseViewLogModal() {
    setIsViewLogModalOpen(false);
  }

  function onHandleOrderLogs() {
    setIsViewLogModalOpen(true);
  }

  async function onHandleDeclineOrder() {
    setNetworkCall(true);
    setIsOrderDeclineLoading(true);
    setIsOrderDeclineConfirmed(false);

    let res = await ApiService.ORDER_STATUS_CHANGE(statusChangeParams, user.token.token);

    if (res.status === "ok" && res.payload.refundInfo) {
      setNetworkCall(false);
      setRefundInfo(res.payload.refundInfo);
      setIsOrderRefundModalOpen(true);
      return;
    }

    if (res.code !== 200) {
      setIsOrderDeclineLoading(false);
      setNetworkCall(false);
      message.error("Failed to decline order!");
      console.error(res.message);
      return;
    }
    message.success("Order is successfully declined!");
    setIsOrderDeclineLoading(false);
    setNetworkCall(false);
    onHandleBack();
  }

  function showDeclineConfirmation() {
    setIsOrderDeclineConfirmed(true);
  }

  function onHandleBack() {
    redirectToTargetPage(navigate);
  }

  const onCancelRefundModal = () => {
    setIsOrderRefundModalOpen(false);
    setTimeout(() => {
      setIsPaymentModalOpen(false);
    }, 100);
  };

  const onFinishPaymentModal = async (result) => {
    if (result.success) {
      setIsPaymentModalOpen(false);
    }
  };

  const onClosePaymentModal = () => {
    setIsPaymentModalOpen(false);
  };

  const onClickPayment = () => {
    if (tableManagement === "Active") {
      const takeout = record.order.orderType === "Dine-in" ? "No" : "Yes";
      navToPayment(navigate, record.order.id, sourcePage, takeout, orderPageNo);
      return;
    }

    setIsPaymentModalOpen(true);
  };

  useEffect(() => {
    const formatedDetails = getFormatedOrderDataForList(record.order);
    setOrderDetails(formatedDetails);
  }, [record.order]);

  return (
    <div className="">
      {/* Log section */}
      <div className="flex items-center justify-between mb-[30px]">
        <div className="text-black">
          <div className="mb-3">
            <div className="text-[18px] leading-[20px] tracking-[0.5px] mb-2">
              <span className="font-p_medium">Order ID:</span>
              <span className="font-p_bold"> {record.order.orderNumber}</span>
            </div>
            <div className="text-[16px]">
              <span className="font-p_medium">Phone: </span>
              <span className="font-p_regular">{`+${record.order.userPhone}`}</span>
            </div>
          </div>
          {record.order.orderType === "Dine-in" && (
            <p className="text-[16px]">
              <span className="font-p_medium">Table number: </span>
              <span className="font-p_regular tracking-[1.2px]">
                {showTableNumbers(record.order.tableNumber, record.order.tables)}
              </span>
            </p>
          )}
          <p className="text-[16px]">
            <span className="font-p_medium">Order Type: </span>
            <span className="font-p_regular tracking-[1.2px]">{record.order.orderType}</span>
          </p>

          {record.order.takeoutType && (
            <p className="text-[16px]">
              <span className="font-p_medium">Takeout Type: </span>
              <span className="font-p_regular tracking-[1.2px]">{record.order.takeoutType}</span>
            </p>
          )}

          <div className="mt-3">
            {record.order.deliveryTime && (
              <p className="font-p_medium">
                Deliver Time:{" "}
                <span className="font-p_semibold">
                  {moment(record.order.deliveryTime).format("MMMM Do YYYY, h:mm A")}
                </span>
              </p>
            )}
            <p>
              <span className="font-p_medium">Created:</span> {moment(record.order.createdAt).format("l")}
            </p>
            <p>
              <span className="font-p_medium">Accepted: </span>
              {moment(record.order.createdAt).format("l")}
            </p>
          </div>
        </div>
        <button
          className="w-[104px] h-[36px] bg-[#FCBD10] text-black text-[15px] 
        leading-[17px] font-semibold rounded-lg"
          onClick={onHandleOrderLogs}
        >
          See logs
        </button>
      </div>

      {/* Food and set menu section */}
      <div className="">
        <h1 className="font-p_semibold text-[18px] leading-[40px] mb-5">Foods and set menus</h1>
        <div className="">
          {record.order.foods.map((food, idx) => {
            return (
              <div key={`${food.foodId}-${idx}`} className="mb-[25px]">
                <OrderedFoodComponent food={food} />
              </div>
            );
          })}
        </div>
      </div>

      {/* subtotal section */}
      <Divider />
      <div>
        <div className="flex font-p_bold">
          <div className="flex-grow"></div>
          <div className="w-[300px]">Subtotal</div>
          <div className="w-[150px] text-right">{getSubtotalPriceToDisplay(record.order).toFixed(2)} TK</div>
        </div>
        {record.order?.staffDiscount?.discountAmount && (
          <div className="flex ">
            <div className="flex-grow"></div>
            <div className="w-[300px]">Discount {record.order.staffDiscount.isDiscountInPercent && <>({record.order.staffDiscount.discount}%)</>}</div>
            <div className="w-[150px] text-right">- {record.order.staffDiscount.discountAmount.toFixed(2)} TK</div>
          </div>
        )}
        {record.order?.loyaltyDiscount && (
          <div className="flex ">
            <div className="flex-grow"></div>
            <div className="w-[300px]">
              {record.order.loyaltyDiscount.discountType === "REDEEM"
                ? `Points Redeemed (${record.order.loyaltyDiscount.redeemedPoints.toFixed(2)})`
                : `Loyalty Discount (${record.order.loyaltyDiscount.discountPercent.toFixed(2)}%)`}
            </div>
            <div className="w-[150px] text-right">
              - {record.order.loyaltyDiscount.discountAmount.toFixed(2)}
              TK
            </div>
          </div>
        )}
        
        {record.order?.couponDiscount && (
          <div className="flex ">
            <div className="flex-grow"></div>
            <div className="w-[300px]">Coupon Discount ({record.order.couponDiscount.couponCode})</div>
            <div className="w-[150px] text-right">- {record.order.couponDiscount.discountAmount.toFixed(2)} TK</div>
          </div>
        )}

        <div className="flex font-p_bold">
          <div className="flex-grow"></div>
          <div className="w-[300px]">Net Total</div>
          <div className="w-[150px] text-right">{(getNetTotalOrderDetails(record.order).toFixed(2))} TK</div>
        </div>
        {!record.order?.isSupplementaryDutyIncluded && getParsedNumber(record.order?.sd) > 0 && 
        <div className="flex">
          <div className="flex-grow"></div>
          <div className="w-[300px]">Supplementary Duty</div>
          <div className="w-[150px] text-right">{record.order.sd.toFixed(2)} TK</div>
        </div>
        }
        {!record.order?.isServiceChargeIncluded && getParsedNumber(record.order?.serviceChargePercent) > 0 && 
        <div className="flex">
          <div className="flex-grow"></div>
          <div className="w-[300px]">Service Charge</div>
          <div className="w-[150px] text-right">{record.order.serviceCharge.toFixed(2)} TK</div>
        </div>
        }

        {!record.order?.isVatIncluded && getParsedNumber(record.order?.vatPercent) > 0 && 
        <div className="flex">
          <div className="flex-grow"></div>
          <div className="w-[300px]">VAT</div>
          <div className="w-[150px] text-right">{record.order.vat.toFixed(2)} TK</div>
        </div>
        }

        <div className="flex font-p_bold">
          <div className="flex-grow"></div>
          <div className="w-[300px]">Gross Total</div>
          {/* <div className="w-[150px] text-right">{record.order.totalPriceBeforeRounding.toFixed(2)} TK</div> */}
          <div className="w-[150px] text-right">{record.order.totalPrice.toFixed(2)} TK</div>
        </div>
      </div>

      <div>
        {record.order?.refundInfo && (
          <>
            <Divider />
            <div className="flex item-center space-x-[30px] py-3">
              {refundInfo?.isRefunded ? (
                <p className="font-p_medium text-green">
                  Refunded: <span>{getParsedNumber(record.order.refundInfo.totalRefundAmount).toFixed(2)} TK</span>
                </p>
              ) : (
                <p className="font-p_medium text-red-600">
                  Refund due: <span>{getParsedNumber(record.order.refundInfo.totalRefundAmount).toFixed(2)} TK</span>
                </p>
              )}
            </div>
          </>
        )}
      </div>
      <Divider className="mt-2 mb-2" />
      <div>
        <div className="flex justify-between items-center ">
          <h1 className="">
            Payment Status:{" "}
            <>
              {record.order.paymentStatus === 0 ? (
                <span className="text-red-600">UNPAID</span>
              ) : (
                <span className="font-ubold text-[#2EC114]">PAID</span>
              )}
            </>
          </h1>
          <h1 className="font-p_bold text-[20px]"></h1>
        </div>
        {record.order.paymentStatus === 1 && (
          <>
            <div className="">Paid by {record.order.paymentType === "SSLC" ? "Online" : record.order.paymentType}</div>
            {record.order.paymentReceiveTypes.length > 0 && (
              <div className="w-[450px] text-[14px] border p-2 mt-2">
                {record.order.paymentReceiveTypes.map((item) => (
                  <div key={item.paymentReceiveType} className="grid grid-cols-[minmax(120px,auto)_150px] mb-1">
                    <div className="flex">
                      <div className="mr-1">{item.paymentReceiveType}</div>
                      <div className="line-clamp-1">
                        {item.refNo ? `(Ref ${item.refNo})` : ""}
                      </div>
                    </div>
                    <div className="text-right">{item.amount.toFixed(2)} TK</div>
                  </div>
                ))}
                <Divider className="mt-1 mb-1" />
                <div className="grid grid-cols-[minmax(120px,auto)_150px] mt-1">
                  <div className="">Returned Amount</div>
                  <div className="text-right">{record.order.totalReturnAmount > 0 ? '-': ''}{record.order.totalReturnAmount.toFixed(2)} TK</div>
                </div>
                <div className="grid grid-cols-[minmax(120px,auto)_150px] mt-1">
                  <div className="">Rounded</div>
                  <div className="text-right">{record.order.rounded.toFixed(2)} TK</div>
                </div>
                <Divider className="mt-1 mb-1" />
                <div className="grid grid-cols-[minmax(120px,auto)_150px] mt-1 font-ubold">
                  <div className="">Total Paid</div>
                  <div className="text-right">{record.order.totalPaidAmount.toFixed(2)} TK</div>
                </div>
              </div>
            )}
          </>
        )}
      </div>
      <Divider />
      <div>
        <div className="flex justify-start items-center mt-3 py-3">
          <h1 className="font-p_bold text-[12px] whitespace-nowrap">Special Instruction:</h1>
          <h1 className="text-[12] ml-2 break-words overflow-hidden">{record.order.comment || "N/A"}</h1>
        </div>
      </div>
      <Divider />

      <div className="mt-5 text-center">
        {!["Completed", "Delivered", "Cancelled"].includes(record.order.orderStatus) && (
          <button
            className="h-[42px] w-[120px] rounded-md text-[14px]"
            style={{
              backgroundColor: record.order?.status === "Pending" ? "#D3D3D3" : "#FF5733", // Light gray if disabled
              color: record.order?.status === "Pending" ? "#A9A9A9" : "#FFFFFF", // Adjust text color for contrast
              fontFamily: "ubold",
              cursor: record.order?.status === "Pending" ? "not-allowed" : "pointer", // Change cursor when disabled
            }}
            onClick={showDeclineConfirmation}
            // disabled={record.order.orderStatus === "Pending"}
          >
            {isOrderDeclineLoading ? <Spin size="small" /> : "Cancel Order"}
          </button>
        )}
        {record.order.refundInfo && !record.order.refundInfo?.isRefunded && (
          <button
            className="bg-green ml-[12px] w-[100px] h-[42px] text-white font-ubold 
          text-sm px-[12px] py-[8px] rounded"
            onClick={() => setIsOrderRefundModalOpen(true)}
          >
            Refund
          </button>
        )}
        <button
          className="bg-black ml-[12px] w-[100px] h-[42px] text-white font-ubold 
          text-sm px-[12px] py-[8px] rounded"
          onClick={onHandleBack}
        >
          Back
        </button>

        {record.order.orderStatus !== "Cancelled" &&
          (record.order.orderStatus === "Pending" || record.order.paymentStatus === 0) && (
            <button
              className="bg-[#FFD700] ml-[12px]  h-[42px] text-pregray font-ubold 
          text-sm px-[12px] py-[8px] rounded"
              onClick={onClickPayment}
            >
              {record.order.orderStatus !== "Pending" && record.order.paymentStatus === 0
                ? "Receive Payment"
                : "Accept"}
            </button>
          )}
      </div>

      {/* order log modal */}
      <ViewOrderLogModal
        openModal={isViewLogModalOpen}
        records={{
          onCancel: onCloseViewLogModal,
          editLogs: editLogs,
          statusLogs: statusLogs,
        }}
      />

      <OrderPaymentModal
        totalAmount={record.order.totalPriceBeforeDiscount}
        cookingTime={"30"}
        openModal={isPaymentModalOpen}
        params={{
          onFinish: onFinishPaymentModal,
          onCancel: onClosePaymentModal,
          order: orderDetails,
        }}
      />
      <ConfirmModal
        isModalOpen={isOrderDeclineConfirmed}
        centered
        records={{
          title: "Are you sure to decline the order?",
          handleOk: onHandleDeclineOrder,
          handleCancel: () => setIsOrderDeclineConfirmed(false),
          confirmText: "Yes",
          cancelconfirmText: "No",
          customStyle: {
            top: 250,
          },
        }}
      />

      {orderDetails.hasOwnProperty("total") && (
        <OrderPaymentRefundModal
          openModal={isOrderRefundModalOpen}
          centered
          params={{
            onCancel: onCancelRefundModal,
            onHandleOk: onCancelRefundModal,
            order: { ...orderDetails, refundInfo },
          }}
        />
      )}
    </div>
  );
}
